(function () {
    'use strict';

    angular
        .module('app')
        .factory('documentDashboardService', documentDashboardService);

    documentDashboardService.$inject = ['$http', '$q', '$localStorage'];

    function documentDashboardService($http, $q, $localStorage) {
        var localStorage = $localStorage;

        var service = {
            getUserOptions: getUserOptions,
            setUserOptions: setUserOptions,
            processing: false
        };

        return service;

        function getUserOptions() {
            service.processing = true;
            var deferred = $q.defer();
            $http.get('../Synergis.WebApi/api/Account/UserSettings/').then(function (response) {
                service.processing = false;
                deferred.resolve(response.data);
            });
            service.processing = false;
            return deferred.promise;
        }

        function setUserOptions(userOptions) {
            var request = $http({
                beforeSend: function (xhr) {
                    xhr.setRequestHeader("Content-Type", "application/json");
                },
                method: 'PUT',
                dataType: 'json',
                contentType: 'application/json',
                crossDomain: true,
                cache: false,
                url: '../Synergis.WebApi/api/Account/UserSettings',
                data: JSON.stringify(userOptions)
            }, function (err, status) {
                console.info('setUserOptions error', err, status);
            });
            return request;
        }
    }
})();